// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__10PG2","description":"PatientConsentPreview_description__QmyrV"};